const getSiteSearchTerm = (state) => state.siteSearchTerm;
const getPortfolioSitesList = (state) => state.portfolioSites;
const getPortfolioSitesLoaded = (state) => state.portfolioSitesLoaded;

export default {
  getSiteSearchTerm,
  getPortfolioSitesList,
  getPortfolioSitesLoaded,
};
